var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ArticleCarousel, ArticleCompactInlineCard, ErrorBoundary } from '@browsing/components';
import { Translate, TranslateScope } from '@pegasus/translation';
import InView from 'react-intersection-observer';
import { trackSelectItem, trackViewItemList } from '@browsing/tracking';
import { CatalogType, NavigationSourceType } from '@browsing/utils';
import { useBiggestDiscount } from './use-biggest-discount';
export var renderCarouselItems = function (item, index) {
    var handleOnClick = function () {
        trackSelectItem({
            element: 'best_deal_carousel',
            itemListName: 'best_deal_carousel',
            context: 'best_deal_carousel',
            item: item,
        }, {
            customMapper: function () { return ({ index: index }); },
        });
    };
    return (React.createElement(ArticleCompactInlineCard, { key: index, brand: item.brand, campaignIdentifier: item.campaignIdentifier, catalogType: CatalogType.BiggestDiscount, handleOnClick: handleOnClick, media: item.media, nameCategoryTag: item.nameCategoryTag, nameColor: item.nameColor, nameShop: item.nameShop, navigationSource: NavigationSourceType.BiggestDiscount, price: item.price, sku: item.sku, specialPrice: item.specialPrice }));
};
var BiggestDiscountCarouselInternal = function (_a) {
    var profileFashionPreference = _a.profileFashionPreference, selectedFashionPreference = _a.selectedFashionPreference, textTitle = _a.textTitle;
    var carouselItems = useBiggestDiscount({
        profileFashionPreference: profileFashionPreference,
        selectedFashionPreference: selectedFashionPreference,
    })[0];
    var onInView = function (inView) {
        if (inView && carouselItems.length > 0) {
            trackViewItemList({
                items: carouselItems,
                element: 'best_deal_carousel',
                context: 'best_deal_carousel',
                itemListName: 'best_deal_carousel',
            });
        }
    };
    if (!carouselItems || carouselItems.length <= 0)
        return null;
    return (React.createElement(InView, { as: "div", onChange: onInView, triggerOnce: true, "data-testid": "biggest-discount-carousel" },
        React.createElement(TranslateScope, { path: "article" },
            React.createElement(ArticleCarousel, { id: "best-deals-headline", title: React.createElement(TranslateScope, null,
                    React.createElement(Translate, { message: "bestDeals.carouselTitle" })), textTitle: textTitle }, carouselItems.map(renderCarouselItems)))));
};
export var BiggestDiscountCarousel = function (props) { return (React.createElement(ErrorBoundary, { componentName: "BiggestDiscountCarousel" },
    React.createElement(BiggestDiscountCarouselInternal, __assign({}, props)))); };
